import { publishOptions } from '@/constants.js'
import Vue from 'vue'
export default {
  state: {
    uploadFile: null,
    uploadImageUrl: null,
    title: null,
    uploadSuccess: null,
    uploadUrl: null,
    uploadedAttachmentUrls: {},
    feildKeyForUploadedAttachmentUrl: null
  },
  mutations: {
    SET_UPLOAD_FILE_OBJ (state, uploadFile) {
      if (uploadFile) {
        state.uploadFile = {}
        state.uploadFile.name = uploadFile.name
        state.uploadFile.type = uploadFile.extension
        state.uploadFile.uploadURL = uploadFile.uploadURL
      } else {
        state.uploadFile = uploadFile
      }
    },
    SET_UPLOAD_IMAGE_URL (state, url) {
      state.uploadImageUrl = url
    },
    SET_UPLOAD_ATTACHMENT_URL (state, data) {
      Vue.set(state.uploadedAttachmentUrls, data.key, data.url)
    },
    SET_UPLOAD_SUCCESS (state, successMsg) {
      state.uploadSuccess = successMsg
    },
    SET_TITLE (state, title) {
      state.title = title
    },
    SET_UPLOAD_URL (state, url) {
      state.uploadUrl = url
    },
    SET_FIELD_KEY_FOR_ATTACHMENT (state, fieldKey) {
      state.feildKeyForUploadedAttachmentUrl = fieldKey
    }
  },
  actions: {
    setUploadFile ({ commit }, fileObj) {
      commit('SET_UPLOAD_FILE_OBJ', fileObj)
    },
    setUploadImageUrl ({ commit }, url) {
      commit('SET_UPLOAD_IMAGE_URL', url)
    },
    setUploadAttachmentUrl ({ commit, state }, url) {
      if (state.feildKeyForUploadedAttachmentUrl) {
        commit('SET_UPLOAD_ATTACHMENT_URL', { key: state.feildKeyForUploadedAttachmentUrl, url: url })
        commit('SET_FIELD_KEY_FOR_ATTACHMENT', null)
      }
    },
    setSuccess ({ commit }, value) {
      commit('SET_UPLOAD_SUCCESS', value)
    },
    setUploadTitle ({ commit }, type) {
      if (type === 'embedded-audio') {
        commit('SET_TITLE', 'EMBEDDED_AUDIO')
      } else {
        // find the obj in publish arr that have the same type, and sent to SET_TITLE this obj.title
        const tempPublishOptions = publishOptions.find(item => item.type === type)
        commit('SET_TITLE', tempPublishOptions.title)
      }
    },
    setUploadUrl ({ commit }, url) {
      commit('SET_UPLOAD_URL', url)
    },
    resetUploadData ({ commit }) {
      commit('SET_UPLOAD_FILE_OBJ', null)
      commit('SET_UPLOAD_IMAGE_URL', null)
      commit('SET_UPLOAD_SUCCESS', null)
      commit('SET_UPLOAD_URL', null)
      this.dispatch('setSelectedVideo', null)
    },
    resetUploadAttachment ({ commit }, feildKey) {
      commit('SET_UPLOAD_ATTACHMENT_URL', { key: feildKey, url: null })
    },
    setFieldKeyForAttachments ({ commit }, fieldKey) {
      commit('SET_FIELD_KEY_FOR_ATTACHMENT', fieldKey)
    }
  }
}
